import React, { useState, useEffect } from 'react';
import 'lightbox.js-react/dist/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Logo from './assets/images/logo.png';
import { useHistory } from 'react-router-dom';

function BookingConfirmationPage() {
  const history = useHistory();
  const [latestBooking, setLatestBooking] = useState(null);

  useEffect(() => {
    let booking = sessionStorage.getItem('booking');
    if (booking === null || booking === undefined) {
      return history.push('/');
    } else {
      setLatestBooking(JSON.parse(booking));
    }
  }, []);

  function clearBooking() {
    sessionStorage.removeItem('booking');
    return history.push('/');
  }

  function redirectToPayment() {
    window.open(`upi://pay?pa=whatsapp@idbi&am=${25000 * latestBooking.stalls.length}`, '_blank');
  }

  return (
    <div className='row w-100 p-1 ms-1'>
      {latestBooking !== null && (
        <div className='row'>
          <div className='col-12 col-lg-6 mx-auto'>
            <div className='card'>
              <div className='card-header text-center'>
                <img src={Logo} style={{ width: '250px' }} />
              </div>
              <div className='card-body'>
                <div>
                  <p>Congratulations! Your stall has been blocked.</p>
                  <p>
                    Please Deposit necessary payment at our help desk and get it booked.
                    {/* You can also make the payment through below
                    mentioned UPI Link. */}
                  </p>
                </div>
                <div className='row'>
                  <div className='col-6' style={{ fontSize: '14px' }}>
                    Stall Numbers
                  </div>
                  <div className='col-6'>: {latestBooking.stalls.join(', ')}</div>
                </div>

                <div className='row'>
                  <div className='col-6' style={{ fontSize: '14px' }}>
                    Company Name
                  </div>
                  <div className='col-6'>: {latestBooking.company}</div>
                </div>

                <div className='row'>
                  <div className='col-6' style={{ fontSize: '14px' }}>
                    Contact Person Name
                  </div>
                  <div className='col-6'>: {latestBooking.contact_person_name}</div>
                </div>

                <div className='row mb-3'>
                  <div className='col-6' style={{ fontSize: '14px' }}>
                    Contact Number
                  </div>
                  <div className='col-6'>: {latestBooking.contact_person_number}</div>
                </div>

                <div>
                  {/* <p>
                    Please share the payment screen shot on{' '}
                    <a href='https://wa.me/919925100680' target='_blank' style={{ textDecoration: 'none' }}>
                      +91 99251 00680
                    </a>
                  </p> */}
                  {/* <p>
                    <span className='mb-1'>PAY Deposit By UPI</span> - <br />
                    <button className='btn btn-success btn-sm w-25 mt-2' onClick={() => redirectToPayment()}>
                      Pay Now
                    </button>
                  </p> */}
                </div>

                <div className='row d-flex justify-content-center mt-4'>
                  <button className='btn btn-primary btn-sm w-50' onClick={() => clearBooking()}>
                    Go Back to Stall Booking
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BookingConfirmationPage;
